<template>
  <div>
    <div class="vx-row">
      <div class="vx-col my-2 w-full md:w-1/5">
        <vx-card title="ค้นหาประวัติการเล่น" class="date-time-card">
          <div>
            <div class="vx-col w-full">
              <label class="my-2 label-style">
                <p>เริ่มต้น:</p>
              </label>
              <flat-pickr :config="configDateTimePicker" v-model="before_datetime" placeholder="Date Time" />
            </div>
            <div class="vx-col w-full mt-4">
              <label class="my-2 label-style">
                <p>สิ้นสุด:</p>
              </label>
              <flat-pickr :config="configDateTimePicker" v-model="after_datetime" placeholder="Date Time" />
            </div>
            <div class="vx-col w-full mt-4">
              <label class="my-2 label-style">
                <p>รายการต่อหน้า:</p>
              </label>
              <vs-input type="number" v-model="perPage" />
            </div>
          </div>
          <vs-button color="primary" @click="onSelectDateTime()" class="mt-4 w-full">ค้นหา</vs-button>
        </vx-card>
      </div>
      <div class="vx-col my-2 w-full md:w-4/5 ">
        <div class="vx-row">
          <div v-if="sumData.length > 0" v-for="data in sumData" :key="'sum-data-of-' + data.game_type"
            class="vx-col md:w-1/5 w-full">
            <result-card :title="data.game_type" :sumAmount="data.sum_amount" :sumWinLose="data.sum_winlose"
              :sumRolling="data.sum_rolling" />
          </div>
        </div>
      </div>
    </div>
    <br />
    <vx-card>
      <vs-table :sst="true" @change-page="handleChangePage" v-model="selected" :total="total" pagination sort
        :noDataText="noDataText" :max-items="perPage" :data="rowData">
        <template slot="thead">
          <vs-th sort-key="betdatetime">Bet Date/Time</vs-th>
          <vs-th sort-key="payoutdatetime">Payout Date/Time</vs-th>
          <vs-th sort-key="game_type">Game</vs-th>
          <vs-th sort-key="username">Username</vs-th>
          <vs-th sort-key="gameid">Game ID</vs-th>
          <vs-th sort-key="betamount">Bet Amount</vs-th>
          <vs-th sort-key="type">Type</vs-th>
          <vs-th sort-key="Before">Before</vs-th>
          <vs-th sort-key="winlost">Win/Lose</vs-th>
          <vs-th sort-key="after">After</vs-th>
          <vs-th sort-key="rollingamount">Rolling</vs-th>
        </template>

        {{ rowData }}
        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].bet_time">
              {{ formatDateTime(data[indextr].bet_time) }}
            </vs-td>

            <vs-td :data="data[indextr].payout_time">
              {{ formatDateTime(data[indextr].payout_time) }}
            </vs-td>
            <vs-td :data="data[indextr].game_type"
              :style="{ color: (gameTypeStyles[data[indextr].game_type] && gameTypeStyles[data[indextr].game_type].color) || '#FFF' }">
              <strong>{{ (gameTypeStyles[data[indextr].game_type] &&
                gameTypeStyles[data[indextr].game_type].displayName) || data[indextr].game_type }}</strong>
            </vs-td>
            <vs-td :data="data[indextr].username">
              {{ data[indextr].username }}
            </vs-td>

            <vs-td :data="data[indextr].gameid">
              {{ data[indextr].gameid }}
            </vs-td>

            <vs-td :data="data[indextr].amount">
              {{ currency(data[indextr].amount) }}
            </vs-td>

            <!-- #MANUAL_REFUND_SYSTEM -->
            <vs-td :data="data[indextr].type" v-if="isRefundable(data[indextr])" style="color: #ffd700">
              <vs-button :disabled="!$store.state.AppActiveUser.permissions.user.action" size="small" color="warning"
                @click="openRefundPopup(data[indextr])" v-if="isGameTypeRefundable(data[indextr].game_type)">
                {{ data[indextr].type }}
              </vs-button>
              <span v-else>
                {{ data[indextr].type }}
              </span>
            </vs-td>
            <!-- END #MANUAL_REFUND_SYSTEM -->
            <vs-td :data="data[indextr].type" v-else-if="data[indextr].type == 'win'" class="text-success">
              <strong>{{ data[indextr].type }}</strong>
            </vs-td>
            <vs-td :data="data[indextr].type" v-else-if="data[indextr].type == 'lose'" class="text-danger">
              <strong>{{ data[indextr].type }}</strong>
            </vs-td>
            <vs-td :data="data[indextr].type" v-else-if="data[indextr].type == 'draw'">
              <strong>{{ data[indextr].type }}</strong>
            </vs-td>
            <vs-td :data="data[indextr].type"
              v-else-if="data[indextr].type == 'cancel' || data[indextr].type == 'refund'" class="text-warning">
              <strong>{{ data[indextr].type }}</strong>
            </vs-td>
            <vs-td :data="data[indextr].type" v-else style="color: #09a3e2">
              {{ data[indextr].type }}
            </vs-td>

            <vs-td :data="data[indextr].bf_balance">
              {{ currency(data[indextr].bf_balance) }}
            </vs-td>

            <vs-td :data="data[indextr].result_amount" v-if="data[indextr].result_amount > 0" class="text-success">
              <vx-tooltip v-if="data[indextr].game_type.includes('PP_')" :text="'WIN: ' +
                currency(
                  parseFloat(data[indextr].amount) +
                  parseFloat(data[indextr].result_amount)
                )
                ">
                {{ currency(data[indextr].result_amount) }}
              </vx-tooltip>
              <span v-else>
                {{ currency(data[indextr].result_amount) }}
              </span>
            </vs-td>
            <vs-td :data="data[indextr].result_amount" v-else-if="data[indextr].result_amount < 0" class="text-danger">
              <vx-tooltip v-if="data[indextr].game_type.includes('PP_')" :text="'WIN: ' +
                currency(
                  parseFloat(data[indextr].amount) +
                  parseFloat(data[indextr].result_amount)
                )
                ">
                {{ currency(data[indextr].result_amount) }}
              </vx-tooltip>
              <span v-else>
                {{ currency(data[indextr].result_amount) }}
              </span>
            </vs-td>
            <vs-td :data="data[indextr].result_amount" v-else>
              <vx-tooltip v-if="data[indextr].game_type.includes('PP_')" :text="'WIN: ' +
                currency(
                  parseFloat(data[indextr].amount) +
                  parseFloat(data[indextr].result_amount)
                )
                ">
                {{ currency(data[indextr].result_amount) }}
              </vx-tooltip>
              <span v-else>
                {{ currency(data[indextr].result_amount) }}
              </span>
            </vs-td>

            <vs-td :data="data[indextr].af_balance">
              {{ currency(data[indextr].af_balance) }}
            </vs-td>

            <vs-td :data="data[indextr].rolling_amount" v-if="data[indextr].rolling_amount > 0">
              {{ currency(data[indextr].rolling_amount) }}
            </vs-td>
            <vs-td :data="data[indextr].rolling_amount" v-else-if="data[indextr].rolling_amount < 0">
              {{ currency(data[indextr].rolling_amount * -1.0) }}
            </vs-td>
            <vs-td :data="data[indextr].rolling_amount" v-else>
              {{ currency(data[indextr].rolling_amount) }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <!-- #MANUAL_REFUND_SYSTEM -->
      <vs-popup title="โปรดยืนยันการคืนเงินติด BET" :active.sync="refundPopupSync">
        <div class="p-2 px-3">
          <h1 class="my-3 text-primary">
            คืนเงินติด BET เกม: {{ refundPopupRow.game_type }}
          </h1>
          <h2 class="text-success my-4">
            Username: {{ refundPopupRow.username }}
          </h2>
          <h2 class="text-warning my-4">
            Game ID: {{ refundPopupRow.gameid }}
          </h2>
          <p class="my-3">
            ระบบจะคืนเครดิตจำนวน
            <big class="text-success">{{
              currency(refundPopupRow.amount)
              }}</big>
            บาท ใหักับลูกค้า
          </p>

          <div class="text-center">
            <vs-button :disabled="$store.state.AppActiveUser.permissions.user.action
                ? false
                : true
              " @click="refundBet" type="filled" size="small" color="warning" icon-pack="feather"
              class="mr-2 my-3">คืนเงิน
            </vs-button>
            <vs-button :disabled="$store.state.AppActiveUser.permissions.user.action
                ? false
                : true
              " @click="closeRefundPopup" type="filled" size="small" color="dark" icon-pack="feather"
              class="mr-2 my-3">ยกเลิก
            </vs-button>
          </div>
        </div>
      </vs-popup>
      <!-- END MANUAL_REFUND_SYSTEM -->
    </vx-card>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import moment from 'moment'
import axios from '../../../axios'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import ResultCard from './result-card.vue'

export default {
  components: {
    vSelect,
    flatPickr,
    ResultCard
  },
  data () {
    return {
      before_datetime: moment.tz('Asia/Bangkok').format('YYYY-MM-DD'),
      after_datetime: moment
        .tz('Asia/Bangkok')
        .add(1, 'days')
        .format('YYYY-MM-DD'),
      configDateTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        time_24hr: true
      },
      searchQuery: '',
      rowData: [],
      rowDatacard: {},
      selected: '',
      // Pagination
      total: 0,
      perPage: 100,
      currentPage: 1,
      noDataText: 'โปรดรอสักครู่ ระบบกำลังดึงข้อมูล...',
      isLoading: true,
      // #MANUAL_REFUND_SYSTEM
      // ใส่ game_type ที่สามารถกด refund ได้
      MANUAL_REFUND_DICT: {
        SAGAME: 'sa',
        KINGMAKER: 'sexy',
        SEXYBCRT: 'sexy',
        WM: 'wm',
        JER: 'jer'
      },
      refundPopupSync: false,
      refundPopupRow: {},
      gameTypeStyles: {
        SEXYBCRT: { displayName: 'SEXY', color: '#ff66cc' },
        KINGMAKER: { displayName: 'KM', color: '#00cd00' },
        SAGAME: { displayName: 'SAGAME', color: '#ffd700' },
        JOKER: { displayName: 'JOKER', color: '#e699ff' },
        PG: { displayName: 'PG', color: '#ffd700' },
        WM: { displayName: 'WM', color: '#00ffff' },
        AMB: { displayName: 'AMB', color: '#80ff00' },
        SBOBET: { displayName: 'SBOBET', color: '#1a1aff' },
        EVO: { displayName: 'EVO', color: '#ff3300' },
        SPP: { displayName: 'SPP', color: '#ff0000' },
        DG: { displayName: 'DG', color: '#ff9933' },
        MG: { displayName: 'MG', color: '#99ffcc' },
        RICH88: { displayName: 'RICH88', color: '#9999ff' },
        ALLBET: { displayName: 'ALLBET', color: '#ffe100' },
        DRAGONGAMING: { displayName: 'DRAGONGAMING', color: '#009900' },
        HOTGRAPH: { displayName: 'HOTGRAPH', color: '#ffd700' },
        AG: { displayName: 'AG', color: '#66ccff' },
        XIN: { displayName: 'XIN', color: '#66ccff' },
        HUAYDRAGON: { displayName: 'HUAYDRAGON', color: '#e699ff' },
        TFG: { displayName: 'TFG', color: '#1a1aff' },
        SPADEGAMING: { displayName: 'SPADEGAMING', color: '#ff0000' },
        DRAGOONSOFT: { displayName: 'DRAGOONSOFT', color: '#9999ff' }
        // Add more game types as needed
      },
      sumData: []
    }
  },
  async mounted () {
    await this.fetchData(true)
  },
  methods: {
    // #MANUAL_REFUND_SYSTEM
    async refundBet () {
      const result = await axios
        .post(
          `/refund/${this.MANUAL_REFUND_DICT[this.refundPopupRow.game_type]}`,
          this.refundPopupRow
        )
        .catch((error) => {
          this.error = error
        })

      if (!this.error && result.data.success) {
        const INFO = `คืนเงินติด BET สำเร็จ ${this.refundPopupRow.game_type}_${this.refundPopupRow.username}_${this.refundPopupRow.gameid}`
        this.$vs.notify({
          title: 'คืนเงินติด BET สำเร็จ',
          text: INFO,
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })

        this.refundPopupRow.type = 'MANUAL_REFUND'
        this.refundPopupRow.result_amount = 0
        this.refundPopupRow.af_balance = this.refundPopupRow.bf_balance
      } else if (!this.error && !result.data.success) this.$vs.notify({
        title: 'คืนเงินติด BET ไม่สำเร็จ',
        text: result.data.description,
        position: 'top-right',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      })
      else this.$vs.notify({
        title: 'เกิดข้อผิดพลาด',
        text: 'โปรดติดต่อโปรแกรมเมอร์',
        position: 'top-right',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      })

      this.closeRefundPopup()
    },
    openRefundPopup (row) {
      this.refundPopupSync = true
      this.refundPopupRow = row
    },
    closeRefundPopup () {
      this.refundPopupSync = false
      this.refundPopupRow = {}
    },
    currency (amount) {
      amount = (amount * 1.0).toFixed(2)
      //SET NULL OR NaN = 0
      if (!amount || amount === 'NaN') {
        amount = 0
      }
      if (amount >= 0) {
        if (typeof amount === 'number') {
          amount = String(Math.abs(amount))
        }
        return amount.replace(/\d(?=(\d{3})+\.)/g, '$&,')
      } else {
        amount = String(amount)
        //return `-${(amount).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
        return amount.replace(/\d(?=(\d{3})+\.)/g, '$&,')
      }
    },
    async fetchData (isFirstLoad = false) {
      const { before_datetime, after_datetime, perPage, currentPage } = this
      const { username } = this.$route.params

      this.rowData = []
      this.noDataText = 'โปรดรอสักครู่ ระบบกำลังดึงข้อมูล...'
      this.isLoading = true

      try {
        const params = {
          timestamp: moment()
        }
        // For first load (not page refresh), get sum data history
        if (isFirstLoad) {
          params.get_sum_data = 'true'
        }
        const result = await axios.get(
          `/member/${username}/pagination/playgameall/${before_datetime}/${after_datetime}/${perPage}/${currentPage}`,
          {
            headers: {
              'Cache-Control': 'no-cache',
              'Pragma': 'no-cache',
              'Expires': '0'
            },
            params
          }
        )

        if (result.data.rows.length <= 0) {
          this.noDataText = 'ไม่พบประวัติการเล่น'
        } else {
          this.rowData = result.data.rows
          this.total = result.data.total
          this.perPage = result.data.perPage
          this.currentPage = result.data.currentPage
          if (result.data.sumData) this.sumData = result.data.sumData
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        this.noDataText = 'เกิดข้อผิดพลาดในการดึงข้อมูล'
      }
    },
    handleChangePage (page) {
      this.currentPage = page
      this.rowData = []
      this.noDataText = 'โปรดรอสักครู่ ระบบกำลังดึงข้อมูล...'

      // Call fetchData to handle the data fetching
      this.fetchData(false)
    },
    async onSelectDateTime () {
      await this.fetchData(true)
    },
    loading (data) {
      if (this.isLoading) return ''
      else return data
    },
    isRefundable (row) {
      return (
        row.type === 'bet' ||
        row.type === 'BET' ||
        (row.type === 'lose' && row.game_type === 'WM')
      )
    },
    isGameTypeRefundable (gameType) {
      return Object.keys(this.MANUAL_REFUND_DICT).includes(gameType)
    },
    formatDateTime (dateTime) {
      try {
        const result = moment(dateTime)
          .tz('Asia/Bangkok')
          .format('YYYY-MM-DD HH:mm:ss')
        if (result === 'Invalid date') {
          return '-'
        }
        return result
      } catch (error) {
        return '-'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}

div.ag-root .ag-cell-focus {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

.date-time-card {
  .vx-col {
    margin-bottom: 1rem;
    /* Adjust the margin as needed */
  }
}

@media (max-width: 768px) {
  .vx-row {
    flex-direction: column;
  }

  .vx-col {
    width: 100% !important;
  }
}

.label-style {
  font-weight: bold;
  color: #FFF;
  /* Darker color for better contrast */
  font-size: 1.1rem;
  /* Slightly larger font size */
  margin-bottom: 0.5rem;
  /* Add some space below the label */
}
</style>
